import React from 'react';

import styled from 'styled-components';

import BulkSelectToggleButton from '../../../lib/BulkSelectToggleButton';
import Button from '../../../lib/Button';
import Notification from '../../../Notification/Notification';
import { useIncentivesDataContext } from '../../IncentivesDataContext';

const SelectorControl = styled.div`
  position: absolute;
  z-index: 10;
  right: 10px;
`;

const IncentivesTableSelectorControl = () => {
  const { items, selectionMode, setSelectionMode, selectedItemsIds, setSelectedItemsIds, setArchivedItemsIds } =
    useIncentivesDataContext();

  const handleCancelSelection = () => {
    setSelectedItemsIds([]);
    setArchivedItemsIds([]);
  };

  const handleSelectionModeChange = () => {
    setSelectionMode((prev: boolean) => !prev);
    setSelectedItemsIds([]);
    setArchivedItemsIds([]);
  };

  return (
    <SelectorControl>
      <Notification
        totalCount={items.length}
        selectedCount={selectedItemsIds.length}
        singularLabel={'incentive'}
        multipleLabel={'incentives'}
        onClose={handleCancelSelection}
        actions={
          <Button
            style={{
              color: 'var(--negative-orange)',
              borderColor: 'var(--negative-orange)',
              backgroundColor: 'var(--light-orange)',
            }}
            onClick={() => setArchivedItemsIds(selectedItemsIds)}
          >
            Archive Multiple
          </Button>
        }
      />
      <BulkSelectToggleButton
        active={selectionMode}
        activeBackgroundColor="var(--light-blue)"
        inactiveBackgroundColor="initial"
        selectedIconSrc="/icons/checklist-blue.svg"
        onClick={handleSelectionModeChange}
      />
    </SelectorControl>
  );
};

export default IncentivesTableSelectorControl;
